//# sourceMappingURL=my-weekday.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-weekday.interface.js
// module id = 870
// module chunks = 9